import {useGetLoginQuery, useLoginEmailVerifyMutation} from '../../redux/loginApi';
import EmailLogin from "./EmailLogin";
import useURLSearchParams from '/src/hooks/useURLSearchParams';
import {useEffect} from 'react';
import ModalLoading from '../Modal/ModalLoading';
import useParseEmailVerify from '/src/hooks/useParseEmailVerify';

const formConfig_email = {
    autoFocus: true,
    saveText: 'Send',
    discardText: '⭯',
    hideDiscard: true,
    fields: [
        {
            key: 'email',
            title: 'Email',
            type: 'email',
            placeholder: 'johndoe@email.com',
            autocomplete: 'email',
            required: true,
        },
    ],
}

export default function RequireLogin({children, allowPublic}){
    const { data: user, error: userError, isLoading: userIsLoading } = useGetLoginQuery(); 
    const [verifyEmailToken, { error: verifyError, isLoading: isVerifying, isSuccess: isVerifySuccess }] = useParseEmailVerify();
    
    const hasError = userError || verifyError;
    const isLoading = userIsLoading || isVerifying;

    if(isLoading && !hasError){
        return (
            <ModalLoading title="Checking" />
        )
    }
    if((user && !hasError) || (allowPublic && !user && !hasError)){
        return children;
    }
    return (
        <div className="absolute inset-0 flex items-center justify-center bg-black">
            <div className="w-1/3 min-w-fit">
                <div className="text-white text-center mx-auto">
                    <h2 className="font-bold text-3xl [text-shadow:0_4px_8px_rgba(0,0,0,0.12)]">Request Access</h2>
                </div>
                <div className="mt-4 mb-4 pb-8 border-2 border-black shadow bg-white">
                    <EmailLogin />
                </div>
                <div className="text-white text-center mx-auto">
                    <p className="text-sm font-light [text-shadow:0_4px_8px_rgba(0,0,0,0.12)]">This site is currently in a closed beta.</p>
                </div>
                <p className="absolute bottom-0 right-0 p-4 text-xs font-light text-white">&copy; 2022 Sensing Places LLC</p>
            </div>
        </div>
    );
}